const FooterComponent = () => {
	return (
		<div className="together-footer-wrap noselect">
			<img
				src={`${process.env.REACT_APP_HOST}/assets/images/main/togetherLogo3.png`}
				className="footer-dangyoung-logo"
			/>
			<div className={`footer-information`}>
				{/*<div className="footer-terms-of-service-wrap">*/}
				{/*</div>*/}
				{/*<Row className="footer-address-privacy-policy-wrap" justify="space-between" wrap={false}>*/}
				<span className="footer-address-text">
					서울 강남구 테헤란로 501, 브이플렉스 5층 516
				</span>
				<span className="footer-address-text-mobile">
					{/*06237 서울 강남구 테헤란로 22길 32{"\n"}4층 (역삼동, 리앤리빌딩)*/}
					서울 강남구 테헤란로 501, 브이플렉스 5층 516
				</span>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<a
						className="footer-terms-of-service-text"
						href="https://dangyoung.com/terms"
						target="_blank"
					>
						이용약관
					</a>
					<a
						className="footer-privacy-policy-text"
						href="https://dangyoung.com/policy"
						target="_blank"
					>
						개인정보처리방침
					</a>
				</div>
				{/*</Row>*/}
			</div>
			<div className="footer-phone-email-wrap">
				T : 1660 - 1024
				<span style={{ marginLeft: 40 }}>E : how2yak@howtoyak.com</span>
			</div>
			<div className="footer-inquiry-wrap">
				<span>채용문의 : recruit@howtoyak.com</span>
				<span className={`division`}>|</span>
				<span>제휴제안문의 : biz@howtoyak.com</span>
			</div>
			<div className="footer-inquiry-wrap">
				<span>광고문의 : ad@howtoyak.com</span>
				<span className={`division`}>|</span>
				<span>기타문의 : contact@howtoyak.com</span>
			</div>
		</div>
	);
};

export default FooterComponent;
